import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Success = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
      fill: colors.illustration.success
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M104.849 53.7691C105.276 54.1227 105.333 54.756 104.978 55.1811L69.3697 97.7111C67.915 99.4485 65.299 99.6399 63.5943 98.1336L42.5603 79.5481C42.1449 79.181 42.1073 78.546 42.4767 78.1325L45.6683 74.5595C46.0348 74.1491 46.6639 74.112 47.0762 74.4763L65.1912 90.4826C65.6129 90.8552 66.2589 90.8066 66.6201 90.3752L99.7343 50.8236C100.088 50.4016 100.715 50.3444 101.139 50.6955L104.849 53.7691Z",
      fill: colors.illustration.bg
    })]
  });
};
//# sourceMappingURL=Success.js.map